<template>
    <div v-if="crafts">
        <v-autocomplete
                v-model="selectedCraft"
                label="Craft"
                item-text="craft"
                item-value="id"
                @change="emitSelected"
                :items="crafts"
                :error-messages="errorMessages"
        />
    </div>
</template>

<script>
    import CRAFTS from "../../graphql/Craft/CraftList.gql";

    export default {
        props: {
            value: {
                type: [String],
                default: ""
            },
            errorMessages: {
              type: Array
            },
        },
        data() {
          return {
            selectedCraft: this.value
          }
        },
        apollo: {
            crafts: {
                query: CRAFTS,
                update: data => data.crafts
            },
        },
        methods: {
            emitSelected(item) {
                this.$emit('input', item)
                this.$emit('selected', item)
            }
        },
    }
</script>
